import { ReactNode } from 'react';
import { darken } from '@mui/material/styles';

import ContactInfo from './ContactInfo';
import { Box, Typography, Paper, Grid, Divider } from '@mui/material';

import mosaic from 'assets/images/mosaic.svg';

type Props = {
  children: ReactNode;
  title: string;
  contentType: string;
  articleId: string;
  lastReviewed: string;
};

const SupportLayout = ({
  children,
  title,
  contentType,
  articleId,
  lastReviewed,
}: Props) => {
  return (
    <>
      <Box
        sx={{
          px: [4, 8, 12],
          height: '9rem',
          display: 'flex',
          alignItems: 'center',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: `url(${mosaic})`,
          bgcolor: (theme) => darken(theme.palette.secondary.light, 0.5),
        }}
      >
        <Typography variant="h3" color="common.white">
          Support
        </Typography>
      </Box>

      <Box
        sx={{
          pt: [0, 2],
          pb: [0, 4],
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          bgcolor: (theme) => theme.palette.grey[100],
        }}
      >
        <Paper
          sx={{
            px: 4,
            py: 5.5,
            minHeight: '40rem',
            width: ['100%', '90%'],
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            fontSize="1.375rem"
            fontWeight={700}
          >
            {title}
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Grid container spacing={4}>
            <Grid item xs={12} md={3} order={[0, 0, 1]}>
              <Box
                sx={{
                  borderLeft: (theme) => [
                    'none',
                    'none',
                    `1px solid ${theme.palette.divider}`,
                  ],
                }}
              >
                <ContactInfo
                  contentType={contentType}
                  articleId={articleId}
                  lastReviewed={lastReviewed}
                />
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={9}
              minWidth={0}
              sx={{
                img: {
                  maxWidth: '100%',
                },
                ol: {
                  pb: 1,
                },
              }}
            >
              {/* 頁面內容 */}
              {children}
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Box
        sx={{
          height: '5rem',
          bgcolor: (theme) => darken(theme.palette.secondary.light, 0.2),
        }}
      ></Box>
    </>
  );
};

export default SupportLayout;
